import React from "react";
import PropTypes from "prop-types";
import { createGlobalStyle, ThemeProvider } from "styled-components";
import { withRouter } from "react-router-dom";
import {
  SiteProvider,
  UserSettingsProvider,
  UserSettingsConsumer
} from "@americanbible/uikit";
import localforage from "localforage";

import { AuthProvider } from "../Auth/AuthContext";
import Footer from "../Footer/Footer";
import SiteHeader from "./SiteHeader/SiteHeader";
import SiteDrawer from "./SiteDrawer";
import theme from "../../utils/theme";
import getParallelsFromQuerystring from "../../utils/getParallelsFromQuerystring";

const GlobalStyles = createGlobalStyle`
  body {
    background-color: ${props => props.theme.background};
    font-family: ${props => props.theme.uiFont};
  }
`;

const SiteWraper = ({ children, location, site }) => {
  const hasParallels = getParallelsFromQuerystring(location.search) > 0;

  return (
    <SiteProvider site={site}>
      <AuthProvider site={site}>
        <UserSettingsProvider store={localforage}>
          <UserSettingsConsumer>
            {({ darkMode }) => (
              <ThemeProvider theme={theme({ site, darkMode })}>
                <>
                  <GlobalStyles />
                  <SiteDrawer theme={theme({ site, darkMode })} />
                  <SiteHeader hasParallels={hasParallels} />
                  <div>{children}</div>
                  <Footer hasParallels={hasParallels} />
                </>
              </ThemeProvider>
            )}
          </UserSettingsConsumer>
        </UserSettingsProvider>
      </AuthProvider>
    </SiteProvider>
  );
};

SiteWraper.propTypes = {
  children: PropTypes.node.isRequired,
  site: PropTypes.shape({}).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string
  }).isRequired
};

export default withRouter(SiteWraper);
